export const getAbbreviatedPriceLabel = (value: number | string): string => {
  const num = Number(value);

  if (Number.isNaN(num)) {
    return String(value);
  }

  if (num === 0) {
    return '$0';
  }

  if (Math.abs(num) >= 1000) {
    return `$${num / 1000}k`;
  }

  return `$${num}`;
};
